import {type BaseFlagProps, type ColorSchemeType} from 'platform/components';
import {Show} from 'platform/foundation';
import {match, Pattern} from 'ts-pattern';

import {isNil} from 'ramda';

import {useGetLeadQualityOptionsQuery} from '@dms/api/sales';

import type {CustomerInsightsLeadQuality} from '../../../types/CustomerInsightsViewModel';
import {CustomerInsightsEnrichmentStatus} from './CustomerInsightsEnrichmentStatus';
import {CustomerInsightsOptionalFlag} from './CustomerInsightsOptionalFlag';

interface CustomerInsightsLeadQualityFlagProps {
  leadQuality: CustomerInsightsLeadQuality | undefined;
}

const getLeadQualityColorScheme = (color: string | undefined) =>
  match<string | undefined, ColorSchemeType>(color)
    .with('blue', () => 'blue')
    .with('yellow', () => 'yellow')
    .with('red', () => 'red')
    .with('gray', () => 'neutral')
    .otherwise(() => 'neutral');

export function CustomerInsightsLeadQualityFlag(props: CustomerInsightsLeadQualityFlagProps) {
  const isVisible = !isNil(props.leadQuality);
  const leadQualityOptionsQuery = useGetLeadQualityOptionsQuery(undefined, {
    skip: !isVisible,
  });
  const {currentData: leadQualityOptions} = leadQualityOptionsQuery;
  const leadQualityOption = leadQualityOptions?.find(
    (option) => option.value === props.leadQuality?.value
  );
  const leadQualityLabel = leadQualityOption?.label ?? props.leadQuality?.label;
  const leadQualityFlag: BaseFlagProps | null = match(leadQualityLabel)
    .with(Pattern.string, (label) => ({
      label,
      colorScheme: getLeadQualityColorScheme(leadQualityOption?.color),
    }))
    .otherwise(() => null);

  return (
    <CustomerInsightsEnrichmentStatus
      isLoading={leadQualityOptionsQuery.isLoading || leadQualityOptionsQuery.isFetching}
      isError={leadQualityOptionsQuery.isError}
      retry={leadQualityOptionsQuery.refetch}
    >
      <Show when={leadQualityFlag}>
        <CustomerInsightsOptionalFlag flag={leadQualityFlag} />
      </Show>
    </CustomerInsightsEnrichmentStatus>
  );
}
